import React from "react";
import connection from "../../../connection";
import general from "../../../general";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import estilosFormulario from "./styles";
import FormularioGenerico from "../FormularioGenerico";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircle} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import SweetAlert from "../../../components/SweetAlertWrapper";
import CustomInput from "../../../components/CustomInput/CustomInput";
import {Radar} from "react-chartjs-2";
import AnexoFormulario from "../../../components/AnexoFormulario/AnexoFormulario";
import Timeline from "../../../components/Timeline/Timeline";
import CardUtilizador from "../../../components/CardUtilizador";

class PaginaFormulario extends React.Component {
  constructor(props) {
    super(props);

    let urlParam = new URLSearchParams(props.location.search);

    this.state = {
      submissoes: [],
      id_submissao: urlParam.get("submissao") || null,
      id_utilizador: urlParam.get("utilizador") || window.App.state.user.id,
      id_percurso: urlParam.get("id_percurso") || null,
      id_curso: urlParam.get("id_curso") || null,
      grupo_fluxo: urlParam.get("grupo_fluxo") || null,
      modal: null
    };

    this.save_timeout = null;
  }

  hideModal = () => {
    this.setState({modal: null});
  }

  componentDidMount() {
    let tipo = this.props.match.params.tipo;

    let url = {
      "pdpe": "forms/obter/pdpe",
      "pfe_dirigente": "forms/obter/pfe_dirigente",
      "parecer_pdpe": "forms/obter/parecer_pdpe",
      "parecer_maturidade_crista": "forms/obter/parecer_maturidade_crista",
      "parecer_pfe_dirigente": "forms/obter/parecer_pfe_dirigente",
      "pfe_chefe_agrupamento": "forms/obter/pfe_chefe_agrupamento",
      "parecer_pfe_chefe_agrupamento": "forms/obter/parecer_pfe_chefe_agrupamento",
      "pedido_investidura_dirigente": "forms/obter/pedido_investidura_dirigente",
      "pfe_regresso_ativo": "forms/obter/pfe_regresso_ativo",
      "parecer_pfe_regresso_ativo": "forms/obter/parecer_pfe_regresso_ativo",
      "parecer_mc_regresso_ativo": "forms/obter/parecer_mc_regresso_ativo",
      "pfe_educadores": "forms/obter/pfe_educadores",
      "parecer_pfe_educadores": "forms/obter/parecer_pfe_educadores",
      "pfe_generico": "forms/obter/pfe_generico",
      "pfe_formador": "forms/obter/pfe_formador",
      "parecer_pfe_formador": "forms/obter/parecer_pfe_formador",
      "pfe_diretor_formacao": "forms/obter/pfe_diretor_formacao",
      "parecer_pfe_diretor_formacao": "forms/obter/parecer_pfe_diretor_formacao",
    }[tipo];

    if (this.state.id_submissao)
      url = "forms/resposta/" + this.state.id_submissao;

    if (!url) {
      window.App.hist.push("/");
      return;
    }

    url += "?utilizador=" + this.state.id_utilizador;

    if (this.state.id_percurso)
      url += "&percurso=" + this.state.id_percurso;

    if (this.state.id_curso)
      url += "&curso=" + this.state.id_curso;

    if (this.state.grupo_fluxo)
      url += "&grupo_fluxo=" + this.state.grupo_fluxo;

    connection.get(url).then((data) => {
      this.setState({
        candidato: data.candidato,
        formulario: data.formulario,
        submissoes: data.submissoes,
        id_submissao: data.submissoes[0]?.id,
        momento: tipo
      })
    });
  }

  submitAnswers = (valores) => {
    this.saveAnswers(valores, true);

    this.setState({
      modal: (
        <SweetAlert
          warning
          title="Submeter"
          onConfirm={async () => {
            try {
              await connection.post("forms/submeter", {
                id_utilizador: this.state.id_utilizador,
                id_submissao: this.state.id_submissao,
              })
              this.componentDidMount();
              this.hideModal();
              general.success("Formulário submetido com sucesso.");
              main.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            } catch (err) {
              console.log(err)
              general.error(err.message);
            }
          }}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.primary
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText="Submeter"
          cancelBtnText="Cancelar"
          showCancel
        >
          Confirma a submissão do formulário?
        </SweetAlert>
      )
    });
  }

  acceptRejectSubmission = (action, final) => {
    let observacoes = "";

    let Content = () => {
      return <CustomInput
        formControlProps={{
          fullWidth: true,
        }}
        inputProps={{
          type: "text",
          placeholder: "Observações",
          multiline: true,
          rows: 3,
          onChange: (e) => {
            observacoes = e.target.value
          }
        }}
      />
    }

    this.setState({
      modal: (
        <SweetAlert
          warning
          title={action === "aceitar" ? "Aceitar" : "Rejeitar"}
          onConfirm={async () => {
            try {
              await connection.post(`forms/aceitar_rejeitar${final ? "_final" : ""}/${this.state.formulario.etiqueta}`, {
                accao: action,
                id_utilizador: this.state.id_utilizador,
                id_submissao: this.state.id_submissao,
                final: final,
                observacoes
              })
              this.componentDidMount();
              this.hideModal();
              general.success("Submissão " + (action === "aceitar" ? "aceite" : "rejeitada") + " com sucesso");
              main.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            } catch (err) {
              console.log(err)
              general.error(err.message);
            }
          }}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + (action === "aceitar" ? this.props.classes.success : this.props.classes.danger)
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText={action === "aceitar" ? "Aceitar" : "Rejeitar"}
          cancelBtnText="Cancelar"
          showCancel
        >
          Tem a certeza que pretende {action === "aceitar" ? "aceitar" : "rejeitar"} esta submissão?
          {action === "rejeitar" && <> A submissão original será duplicada para permitir a correção proposta</>}
          <Content/>
        </SweetAlert>
      )
    });
  }

  reabrirSubmissao = () => {
    let observacoes = "";

    let Content = () => {
      return <CustomInput
        formControlProps={{
          fullWidth: true,
        }}
        inputProps={{
          type: "text",
          placeholder: "Observações",
          multiline: true,
          rows: 3,
          onChange: (e) => {
            observacoes = e.target.value
          }
        }}
      />
    }

    this.setState({
      modal: (
        <SweetAlert
          warning
          title={"Reabrir submissão"}
          onConfirm={async () => {
            try {
              await connection.post(`forms/reabrir`, {
                id_utilizador: this.state.id_utilizador,
                id_submissao: this.state.id_submissao,
                etiqueta: this.state.formulario.etiqueta,
                observacoes
              })
              this.componentDidMount();
              this.hideModal();
              general.success("Submissão reaberta com sucesso");
              main.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            } catch (err) {
              console.log(err)
              general.error(err.message);
            }
          }}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.warning
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText={"Reabrir"}
          cancelBtnText="Cancelar"
          showCancel
        >
          Tem a certeza que pretende reabrir esta submissão?
          A submissão atual será rejeitada e o candidato teré que preencher um novo formulário.
          <Content/>
        </SweetAlert>
      )
    });
  }

  saveAnswers = (valores, skipTimeout = false, show_message = false) => {
    let submissoes = this.state.submissoes;
    let submissao = submissoes.find(s => s.id === this.state.id_submissao);
    submissao.respostas = valores;

    clearTimeout(this.save_timeout);

    const go = () => {
      connection.post("forms/guardar", {
        id_utilizador: this.state.id_utilizador,
        id_submissao: this.state.id_submissao,
        etiqueta: this.state.formulario.etiqueta,
        versao: this.state.formulario.versao,
        respostas: valores
      }).then(() => {
        if (show_message)
          general.success("Formulário guardado com sucesso.");
      }).catch((err) => {
        console.log(err)
        general.error(err.message);
      });
    }

    if (skipTimeout) {
      go();
      return;
    }

    this.save_timeout = setTimeout(go, 600);
  }

  render() {
    const {classes} = this.props;

    if (!this.state.formulario) return null;
    let submissao = this.state.submissoes.find(s => s.id === this.state.id_submissao);

    let label_utilizador = {
      "pfe_dirigente": "Perfil do candidato",
      "pfe_chefe_agrupamento": "Perfil do dirigente",
      "pfe_regresso_ativo": "Perfil do candidato",
      "pfe_educadores": "Perfil do dirigente",
      "pfe_formador": "Perfil do dirigente",
      "pfe_diretor_formacao": "Perfil do dirigente",
    }[this.state.formulario.etiqueta];

    let label_meta = {
      "pfe_dirigente": "Perfil de dirigente",
      "pfe_chefe_agrupamento": "Perfil de chefe de unidade",
      "pfe_regresso_ativo": "Perfil de dirigente",
      "pfe_educadores": "Perfil de chefe de unidade",
      "pfe_formador": "Perfil de formador",
      "pfe_diretor_formacao": "Perfil de diretor de formação",
    }[this.state.formulario.etiqueta];

    let dados_grafico = (() => {
      if (!["OBJETIVOS_PFE"].includes(submissao?.extra?.tipo))
        return false;

      let label = [];
      let minimoObjetivos = [];
      let respostas = [];

      this.state.formulario.conteudo.etapas.forEach(({config, questoes, ...etapa}) => {
        config = {...this.state.formulario.conteudo.config, ...config};

        questoes.forEach(({config: configQuestao, ...questao}, idx_questao) => {
          configQuestao = {...config, ...configQuestao};
          label.push(etapa.id + "." + questao.id);
          minimoObjetivos.push(configQuestao._minimo_objetivos);
          respostas.push(submissao.respostas[etapa.id + "." + questao.id]?.valor);
        })
      });

      return {
        label,
        minimoObjetivos,
        respostas
      };
    })();

    let mensagem = null;
    if (this.state.formulario.etiqueta === "pdpe") {
      mensagem = <>
        A formulação do PDPE baseia-se no estabelecimento, em face dos objetivos educativos finais não cumpridos ou mais
        fracamente cumpridos, de metas concretas e a forma de as atingir, designadamente através da frequência de
        oportunidades formativas formais, da formação através do exercício de funções ou responsabilidades específicas,
        ou outras formas que se mostrem adequadas e exequíveis, bem como prazos.
      </>;
    }

    if (submissao?.data_submissao && !submissao.data_validacao && !submissao.data_rejeicao && general.userHasPermission("formulario.aprovar"))
      mensagem = <>
        Esta submissão está pendente de validação. Verifique as informações introduzidas e clique em "Rejeitar" ou "Aceitar" no fundo da página.
        <br/>Caso exista algum erro no preenchimento do formulário, pode rejeitar a submissão e corrigir os erros antes de fazer um novo envio.
      </>;

    if (this.state.formulario.etiqueta === "pfe_generico") {
      mensagem = <>
        O Plano de Formação Específico (PFE) é um instrumento de planeamento individualizado da formação do Dirigente. Poderá preencher este formulário como diagnóstico para um percurso que venha a realizar. Este formulário não pode ser submetido, mas poderá ser guardado e editado a qualquer momento.
      </>;
    }

    return <div className={classes.PaginaFormulario}>
      {this.state.modal}
      <div className={classes.eventLabel}>
        <p>Formulário</p>
        <h2>{{
          pdpe: "Perfil de Desenvolvimento Pessoal Escutista",
          pfe_dirigente: "Plano de Formação Específico",
          parecer_pdpe: "Parecer de PDPE",
          parecer_maturidade_crista: "Parecer de Maturidade Cristã",
          pedido_investidura_dirigente: "Pedido de Investidura Dirigente",
          parecer_pfe_dirigente: "Parecer de PFE",
          pfe_regresso_ativo: "Plano de Formação Específico",
          pfe_educadores: "Plano de Formação Específico",
          pfe_generico: "Plano de Formação Específico",
        }[this.state.formulario.etiqueta]}</h2>
      </div>
      {mensagem && <Card>
        <CardBody>
          {mensagem}
        </CardBody>
      </Card>}
      <div className={classes.colunas}>
        {this.state.submissoes && <Card className={classes.listaSubmissoes} style={{paddingTop: "0"}}>
          <CardUtilizador compact utilizador={this.state.candidato} label={this.state.candidato.NIN} pode_ver_utilizador={true} inline={true} enviar_email={false}/>
          {this.state.submissoes.map((submissao) => {
            return <div key={submissao.id} className={classes.submissaoLista + (submissao.data_submissao ? " visto" : "") + (this.state.id_submissao === submissao.id ? " active" : "")} onClick={() => {
              this.setState({id_submissao: submissao.id});
            }}>
              <p className={"top"}>
                <span className={"subject"}>{submissao.designacao}</span>
                {submissao.data_submissao ? null : (<FontAwesomeIcon icon={faCircle}/>)}
              </p>
              {[
                submissao.data_rejeicao && <p className={"bottom"}>
                  <span className={"date"}>Rejeitado em: {moment(submissao.data_rejeicao).format("DD/MM/YYYY [às] H:mm")}</span>
                </p>,
                submissao.data_validacao && <p className={"bottom"}>
                  <span className={"date"}>Validado em: {moment(submissao.data_validacao).format("DD/MM/YYYY [às] H:mm")}</span>
                </p>,
                submissao.data_submissao && <p className={"bottom"}>
                  <span className={"date"}>Submetido em: {moment(submissao.data_submissao).format("DD/MM/YYYY [às] H:mm")}</span>
                </p>,
                <p className={"bottom"}>
                  <span className={"date"}>Atualizado em: {moment(submissao.data_atualizacao).format("DD/MM/YYYY [às] H:mm")}</span>
                </p>
              ].filter(Boolean)[0]}
            </div>;
          })}
        </Card>}
        <div>
          {submissao?.historico && submissao.historico.length > 0 && <Card className={classes.formulario}>
            <CardBody>
              <h6 style={{fontSize: "18px", marginLeft: "18px", marginBottom: "-25px"}}>Histórico</h6>
              <Timeline stories={submissao?.historico.map((h, i) => {
                return {
                  inverted: true,
                  estado: h.estado_avaliacao,
                  designacao: <>{h.designacao} {h.estado_avaliacao === 'submetido_validado' ? "submetido" : h.estado_avaliacao} por: {h.nome_ultima_alteracao} - {h.nin_ultima_alteracao}</>,
                  data_alteracao: h.data_alteracao,
                  observacao: h.observacao
                };
              })}></Timeline>
            </CardBody>
          </Card>}

          {dados_grafico && <Card>
            <CardBody>
              <Radar
                data={{
                  labels: dados_grafico.label,
                  onHover: false,
                  datasets: [
                    {
                      backgroundColor: 'rgba(0, 147, 68, 0.5)',
                      borderColor: 'rgba(0, 147, 68, 1)',
                      pointBackgroundColor: 'rgba(0, 147, 68, 1)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgba(179,181,198,1)',
                      label: label_meta,
                      data: dados_grafico.minimoObjetivos
                    }, {
                      backgroundColor: 'rgba(255,0,0,0.2)',
                      borderColor: 'rgb(255,131,36)',
                      pointBackgroundColor: 'rgba(255,0,0,1)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgba(179,181,198,1)',
                      label: label_utilizador,
                      data: dados_grafico.respostas
                    }
                  ]
                }}
                options={{
                  scale: {
                    ticks: {
                      min: 0,
                      max: 4,
                      stepSize: 1
                    }
                  },
                  legend: {
                    display: true,
                    position: "right"
                  }
                }}/>
            </CardBody>
          </Card>}

          <Card className={classes.formulario}>
            <CardBody>
              <FormularioGenerico
                key={this.state.id_submissao}
                formulario={this.state.formulario.conteudo}
                onSubmit={this.submitAnswers}
                extra={submissao?.extra}
                valores_defeito={submissao?.respostas}
                onChange={this.saveAnswers}
                onSave={(valores) => {
                  this.saveAnswers(valores, true, true);
                }}
                enableSubmit={!submissao?.data_submissao && this.state.formulario.abstrato !== 1}
                enableSave={this.state.formulario.abstrato === 1}
                enableEdit={!submissao?.data_submissao}
                actions={[
                  submissao?.data_submissao && !submissao.data_validacao_preliminar && !submissao.data_validacao && !submissao.data_rejeicao && (general.userHasPermission("submissao.aprovar") || general.userHasPermission("submissao.aprovar_continuo")) && {
                    label: "Rejeitar",
                    color: "danger",
                    onClick: () => this.acceptRejectSubmission("rejeitar", false)
                  },
                  submissao?.data_submissao && !submissao.data_validacao_preliminar && !submissao.data_validacao && !submissao.data_rejeicao && (general.userHasPermission("submissao.aprovar") || general.userHasPermission("submissao.aprovar_continuo")) && {
                    label: "Aprovar",
                    color: "success",
                    onClick: () => this.acceptRejectSubmission("aceitar", false)
                  },
                  submissao?.data_submissao && submissao.data_validacao_preliminar && !submissao.data_validacao && !submissao.data_rejeicao && (general.userHasPermission("submissao.aprovar_final") || general.userHasPermission("submissao.aprovar_continuo")) && {
                    label: "Rejeitar",
                    color: "danger",
                    onClick: () => this.acceptRejectSubmission("rejeitar", true)
                  },
                  submissao?.data_submissao && submissao.data_validacao_preliminar && !submissao.data_validacao && !submissao.data_rejeicao && (general.userHasPermission("submissao.aprovar_final") || general.userHasPermission("submissao.aprovar_continuo")) && {
                    label: "Aprovar",
                    color: "success",
                    onClick: () => this.acceptRejectSubmission("aceitar", true)
                  },
                  submissao?.data_submissao && submissao.data_validacao && !submissao.data_rejeicao && !submissao.nao_pode_reabrir && (general.userHasPermission("submissao.reabrir")) && {
                    label: "Reabrir",
                    color: "warning",
                    onClick: () => this.reabrirSubmissao()
                  },
                ].filter(a => a)}/>
            </CardBody>
          </Card>
          {this.state.formulario.abstrato !== 1 && <AnexoFormulario utilizador={this.state.id_utilizador} submissao={submissao} reload={() => this.componentDidMount()}/>}
        </div>
      </div>
    </div>;
  }
}

export default withStyles(estilosFormulario)(PaginaFormulario);
